import React, { useState } from 'react';
import Dropdown from '@uilib/business-components/Dropdown';
import Tooltip from '@uilib/business-components/Tooltip';

import i18n from 'Services/i18n';

const DropdownWrapper = React.forwardRef((props, ref) => {
    return (
        <Dropdown
            {...props}
            testDataLabel="eid-dropdown"
            ref={ref}
            title={i18n(props.title)}
            content={
                props.content
                    ? props.content.map(({ header, items }) => ({
                          header: i18n(header),
                          items: items.map((item) => ({
                              ...item,
                              title: i18n(item.title),
                          })),
                      }))
                    : null
            }
        />
    );
});

export default DropdownWrapper;

const DropdownWithTooltipWrapper = React.forwardRef((props, ref) => {
    const [isOpen, setIsOpen] = useState(false);

    return (
        <Tooltip tooltipContent={i18n(props.tooltipContent)} disabled={isOpen || !props.tooltipContent}>
            <span>
                <DropdownWrapper
                    ref={ref}
                    onShow={() => {
                        setIsOpen(true);
                    }}
                    onHide={() => {
                        setIsOpen(false);
                    }}
                    {...props}
                />
            </span>
        </Tooltip>
    );
});

export { DropdownWithTooltipWrapper as DropdownWithTooltip };
